import { useTheme } from '@material-ui/core';

const LogoIcon = () => {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  return (
    <img
      src={isDark ? '/flow-logo-white.png' : '/flow-logo-indigo.png'}
      alt="Flow"
      width={36}
      height={36}
      style={{ objectFit: 'contain', display: 'block' }}
    />
  );
};

export default LogoIcon;
